/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThermoformingBase } from '../../models/thermoforming-base';

export interface MgmtThermoformingBaseControllerSortDown$Params {
  id: number;
}

export function mgmtThermoformingBaseControllerSortDown(http: HttpClient, rootUrl: string, params: MgmtThermoformingBaseControllerSortDown$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
  const rb = new RequestBuilder(rootUrl, mgmtThermoformingBaseControllerSortDown.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingBase>;
    })
  );
}

mgmtThermoformingBaseControllerSortDown.PATH = '/api/mgmt/thermoforming-base/{id}/sort-down';
